package com.wintermar.inspection.core.ui.component.location

import androidx.compose.runtime.Composable
import com.wintermar.inspection.core.ui.component.location.util.LocationModel

@Composable
actual fun LocationModal(
    title: String,
    location: String,
    show: Boolean,
    onDismiss: () -> Unit,
    onSave: (String, LocationModel?) -> Unit
) {
    LocationDialog(
        title = title,
        address = location,
        show = show,
        onDismiss = onDismiss,
        onSave = onSave
    )
}
